import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { getColorStatus } from "../funciones/colors";

ChartJS.register(ArcElement, Tooltip, Legend);

const GraficoTorta = ({ datos }) => {
  const data = {
    labels: datos.map((d) => d.label),
    datasets: [
      {
        data: datos.map((d) => d.valor),
        backgroundColor: datos.map((d) => getColorStatus(d.label)),
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        align: "center",
        labels: {
          boxWidth: 14,
          boxHeight: 14,
          padding: 14,
          font: { size: 12 },
        },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const label = ctx.label || "";
            const value = ctx.parsed || 0;
            const total = ctx.dataset.data.reduce((a, b) => a + b, 0);
            const pct = total ? ((value / total) * 100).toFixed(1) : 0;
            return `${label}: ${value} (${pct}%)`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "380px" }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default GraficoTorta;